import React from 'react';

const ContactInfo = ({ whatsappNumber, websiteUrl }) => {
  return (
    <div className="flex flex-col items-center text-center text-white p-6 bg-gray-800 rounded-2xl shadow-2xl mt-8">
      <h2 className="text-xl font-semibold mb-4 text-yellow-500">Contacto y Pedidos Musicales</h2>
      <p className="text-lg mb-4">
        Envíanos tus pedidos musicales por WhatsApp:
      </p>
      <a
        href={`https://wa.me/${whatsappNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-green-500 text-white py-3 px-6 rounded-lg shadow-md hover:bg-green-600 transition-colors text-lg font-medium mb-4"
      >
        WhatsApp: {whatsappNumber}
      </a>
      <p className="text-lg mb-4">
        Visita nuestra web:
      </p>
      <a
        href={websiteUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-blue-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-blue-700 transition-colors text-lg font-medium"
      >
        {websiteUrl.replace('https://', '').replace('http://', '')}
      </a>
    </div>
  );
};

export default ContactInfo;